export const SALESGOD_PERSONAS = [
  {
    id: 'rico',
    name: 'Nico',
    group: 'casual',
    groupLabel: 'Casual',
    image: '/img/greg.webp',
    tagline: 'Streetwise & Direkt',
    description: 'Schreibt wie eine WhatsApp-Nachricht – kurz, frech, auf den Punkt.',
  },
  {
    id: 'mila',
    name: 'Lena',
    group: 'casual',
    groupLabel: 'Casual',
    image: '/img/Louisa.webp',
    tagline: 'Warm & Witzig',
    description: 'Storytelling mit Humor – wie eine clevere Freundin mit Insider-Tipps.',
  },
  {
    id: 'alex',
    name: 'Tobias',
    group: 'normal',
    groupLabel: 'Normal',
    image: '/img/kane.webp',
    tagline: 'Clean & Sharp',
    description: 'Klar, direkt, kein Wort zu viel. Smarter LinkedIn-Vibe.',
  },
  {
    id: 'nora',
    name: 'Hannah',
    group: 'normal',
    groupLabel: 'Normal',
    image: '/img/marianne.webp',
    tagline: 'Analytisch & Clever',
    description: 'Daten-getrieben, stellt die richtigen Fragen. Consultant-Energy.',
  },
  {
    id: 'dr_kessler',
    name: 'Dr. Weber',
    group: 'formal',
    groupLabel: 'Formal',
    image: '/img/marie.webp',
    tagline: 'Premium & Geschliffen',
    description: 'Alte Schule Eloquenz. Jedes Wort sitzt wie ein Maßanzug.',
  },
  {
    id: 'victoria',
    name: 'Katharina',
    group: 'formal',
    groupLabel: 'Formal',
    image: '/img/Mary.webp',
    tagline: 'C-Level & Strategisch',
    description: 'Kühl, strategisch, auf Augenhöhe mit Entscheidern.',
  },
];

export const PERSONA_GROUPS = [
  { id: 'casual', label: 'Casual' },
  { id: 'normal', label: 'Normal' },
  { id: 'formal', label: 'Formal' },
];

export const getPersonaById = (id) => SALESGOD_PERSONAS.find(p => p.id === id) || null;
